import React, { FC, useState } from 'react';
import styled from '@material-ui/styles/styled';
import CustomMenuListPopup from './CustomMenuListPopup';
import { CustomMenuItem } from 'src/config/api/models/CustomMenu';
import { SpriteIcon } from 'src/config/api/models/FontAwesome';
import IconButtonSecondary from '../buttons/IconButtonSecondary';

const CustomMenuListWrapper = styled('div')({
  position: 'relative',
  display: 'flex',
  alignSelf: 'stretch',
});

export type CustomMenuListProps = {
  menuItemsList?: CustomMenuItem[];
  icon?: SpriteIcon;
  square?: boolean;
  variant?: 'primary' | 'secondary';
  customWidth?: number;
  iconSize?: 'lg' | 'md' | 'sm';
} & React.HTMLAttributes<HTMLDivElement>;

const CustomMenuList: FC<CustomMenuListProps> = ({
  menuItemsList = [],
  icon,
  square,
  variant = 'primary',
  customWidth,
  iconSize,
  ...other
}) => {
  const [open, setOpen] = useState(false);
  return (
    <CustomMenuListWrapper {...other}>
      <IconButtonSecondary
        square={square}
        icon={icon}
        iconSize={iconSize ?? 'md'}
        fullWrapper={variant === 'primary'}
        onClick={() => setOpen(!open)}
      />
      {open && (
        <CustomMenuListPopup
          menuItemsList={menuItemsList}
          variant={variant}
          onClose={() => setOpen(false)}
          customWidth={customWidth}
        />
      )}
    </CustomMenuListWrapper>
  );
};

export default CustomMenuList;
